import React from 'react';

import { Container, Navbar } from 'react-bootstrap';
import BtnNavbar from '../elements/BtnNavbar';
import BtnLogOut from '../elements/BtnLogOut';
import { useAuth } from '../context/AuthContext';



const NavContainer = () => {

    const {user} = useAuth();

    return ( 
        <Navbar className="bg-body-tertiary">
        <Container fluid>
           <BtnNavbar></BtnNavbar>
           <BtnLogOut></BtnLogOut>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Navbar.Text>
              Usuario: <a href="#login">{user.email}</a>
            </Navbar.Text>
          </Navbar.Collapse>
        </Container>
      </Navbar>
     );
}
 
export default NavContainer;